import { DialogTypes as types } from '../types'

export const setDialog = data => ({
    type: types.SET_DIALOG,
    data
})

export const closeDialog = () => ({ type: types.CLOSE_DIALOG })